export const userTypes = {
  designer: 'designer',
  buyer: 'buyer',
  buyerAdmin: 'buyer_admin',
  buyerUser: 'buyer_user',
  personal: 'personal',
  buyDesignAdmin: 'bd_admin',
  admin: 'admin',
};
